import React from 'react';
import './InfoPage.css';

const PrivacyPolicy = () => {
  return (
    <div className="info-page">
      <div className="info-container">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>

        <section>
          <h2>1. Introduction</h2>
          <p>
            Welcome to VIT CGPA Calculator. We respect your privacy and are committed to protecting your personal data. 
            This privacy policy explains how we collect, use, and safeguard your information when you use our website.
          </p>
        </section>

        <section>
          <h2>2. Information We Collect</h2>
          <p>We collect the following types of information:</p>
          <ul>
            <li><strong>Data You Provide:</strong> When you use our calculator, you may enter academic data (GPA, credits, grades) which is stored locally in your browser.</li>
            <li><strong>Account Information:</strong> If you create an account, we collect your name and email address.</li>
            <li><strong>Usage Data:</strong> We may collect information about how you interact with our website.</li>
          </ul>
        </section>

        <section>
          <h2>3. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Provide and improve our CGPA calculation services</li>
            <li>Save your calculations locally in your browser</li>
            <li>Respond to your inquiries and provide customer support</li>
            <li>Analyze website usage to improve user experience</li>
          </ul>
        </section>

        <section>
          <h2>4. Data Storage</h2>
          <p>
            Your calculation data is stored locally in your browser using localStorage. We do not transmit this data 
            to our servers. Account information (if you create an account) is stored securely.
          </p>
        </section>

        <section>
          <h2>5. Third-Party Services</h2>
          <p>
            We may use third-party services such as Google AdSense for advertising. These services may collect 
            information about your visits to our website and other websites. Please review their privacy policies 
            for more information.
          </p>
        </section>

        <section>
          <h2>6. Cookies</h2>
          <p>
            We use cookies to enhance your experience, analyze site usage, and assist in our marketing efforts. 
            You can control cookies through your browser settings.
          </p>
        </section>

        <section>
          <h2>7. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access your personal data</li>
            <li>Request correction of inaccurate data</li>
            <li>Request deletion of your data</li>
            <li>Opt-out of data collection</li>
          </ul>
        </section>

        <section>
          <h2>8. Security</h2>
          <p>
            We implement appropriate security measures to protect your information. However, no method of 
            transmission over the internet is 100% secure.
          </p>
        </section>

        <section>
          <h2>9. Children's Privacy</h2>
          <p>
            Our website is not intended for children under 13. We do not knowingly collect personal information 
            from children under 13.
          </p>
        </section>

        <section>
          <h2>10. Changes to This Policy</h2>
          <p>
            We may update this privacy policy from time to time. We will notify you of any changes by posting 
            the new policy on this page.
          </p>
        </section>

        <section>
          <h2>11. Contact Us</h2>
          <p>
            If you have questions about this privacy policy, please contact us through our website.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;

